"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moneyHelper = require("./moneyHelper");

require("./Price.css");

function Price(props) {
  var amount = props.amount,
      amountBeforeDiscount = props.amountBeforeDiscount,
      amountLabel = props.amountLabel,
      amountBeforeDiscountLabel = props.amountBeforeDiscountLabel,
      className = props.className,
      intlMoneyFormatObj = props.intlMoneyFormatObj,
      moneyFormatString = props.moneyFormatString,
      textAlign = props.textAlign,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["amount", "amountBeforeDiscount", "amountLabel", "amountBeforeDiscountLabel", "className", "intlMoneyFormatObj", "moneyFormatString", "textAlign"]);

  var getFormattedPrice = function getFormattedPrice(price) {
    if (moneyFormatString) {
      return (0, _moneyHelper.formatMoneyCustomized)(price, moneyFormatString);
    } else {
      return (0, _moneyHelper.formatMoneyByInternationalizationStandard)(price, intlMoneyFormatObj);
    }
  };

  if (amount !== null) {
    var priceClassNames = (0, _classnames["default"])(['stx-price', className, {
      'stx-price--alight-left': textAlign === 'left'
    }, {
      'stx-price--alight-center': textAlign === 'center'
    }, {
      'stx-price--alight-right': textAlign === 'right'
    }]);
    var amountClassNames = (0, _classnames["default"])(['stx-price__amount', {
      'stx-price__amount--inactive': amountBeforeDiscount !== null
    }]);
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
      className: priceClassNames
    }, otherProps), amountBeforeDiscount !== null && /*#__PURE__*/_react["default"].createElement("p", {
      className: amountClassNames,
      "aria-label": amountBeforeDiscountLabel
    }, getFormattedPrice(amountBeforeDiscount)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "stx-price__amount",
      "aria-label": amountLabel
    }, getFormattedPrice(amount)));
  }

  return null;
}

Price.defaultProps = {
  className: '',
  textAlign: 'center',
  amount: null,
  amountBeforeDiscount: null,
  amountLabel: 'Product price',
  amountBeforeDiscountLabel: 'Price before discount',
  moneyFormatString: null,
  intlMoneyFormatObj: {
    languageTag: 'en-CA',
    currency: 'CAD'
  }
};
Price.propTypes = {
  /** Value appended to the class attribute */
  className: _propTypes["default"].string,

  /** How the price text should be aligned */
  textAlign: _propTypes["default"].oneOf(['left', 'center', 'right']),

  /** Value of the price amount (cents), for example: $24.99 would be 2499. */
  amount: _propTypes["default"].number,

  /** Description for the price component, used by screen readers (accessibility purposes). */
  amountLabel: _propTypes["default"].string,

  /** Value of the discounted price amount (cents), for example: $24.99 should be passed as 2499. */
  amountBeforeDiscount: _propTypes["default"].number,

  /** Description for the component that shows price before discount, used by screen readers (accessibility purposes). */
  amountBeforeDiscountLabel: _propTypes["default"].string,

  /** A formatting string, examples: 'CA${{amount}}', '€{{amount_with_comma_separator}}' */
  moneyFormatString: _propTypes["default"].string,

  /** The formatting object */
  intlMoneyFormatObj: _propTypes["default"].object
};
var _default = Price;
exports["default"] = _default;